<template>
    <center-layout>
        <h2 class="pb-2" @click="fetch_data">
            <v-row>
                <v-col>
                    Entries
                </v-col>
                <v-col cols="2" class="text-right">
                    <v-btn icon to="/entries/new">
                        <v-icon color="primary">mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </h2>

        <v-alert type="error" v-if="error" v-text="error" />

        <v-progress-linear
            color="primary lighten-1"
            background-color="primary lighten-4"
            indeterminate
            v-if="!data_loaded"
        ></v-progress-linear>

        <div v-if="data_loaded && entries.length > 0">
            <v-card
                class="diario--entry"
                outlined
                v-for="entry in sorted_entries"
                :key="entry.filename"
                :to="`/entries/${entry.filename}`"
            >
                <v-card-title class="text-wrap--break" v-text="entry.title" />
                <v-card-subtitle v-text="human_readable_date(entry.date)" />
            </v-card>
        </div>

        <v-card
            class="diario--entry"
            outlined
            v-if="data_loaded && entries.length === 0"
        >
            <v-card-title class="text-wrap--break">
                You have no entries yet
            </v-card-title>
            <v-card-subtitle>
                Create some by clicking on the
                <v-icon>mdi-plus</v-icon> button in the navigation bar.
            </v-card-subtitle>
        </v-card>
    </center-layout>
</template>

<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
import CenterLayout from "../components/CenterLayout.vue";

export default {
    name: "Entries",
    components: { CenterLayout },
    data: function() {
        return {
            entries: [],
            data_loaded: false,
            error: false
        };
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
        sorted_entries: function() {
            let entries = this.entries;
            entries.sort((a, b) => {
                let comparison = new Date(b.date) - new Date(a.date);
                return comparison === 0 ? 0 : comparison;
            });
            return entries;
        }
    },
    mounted() {
        this.fetch_data();

        if (this.$route.query.error) {
            switch (this.$route.query.error) {
                case "storage/object-not-found":
                    this.error =
                        "The entry you were trying to access does not exist.";
                    break;
                case "storage/unauthorized":
                    this.error = "You are not allowed to access that entry.";
                    break;
                case "storage/cancelled":
                    this.error = "You cancelled the action.";
                    break;
            }
        }
    },
    methods: {
        fetch_data: function() {
            this.data_loaded = false;

            let database_reference = firebase
                .database()
                .ref()
                .child(this.user.data.uid);

            this.entries = [];

            database_reference.on("value", snapshot => {
                let files = snapshot.val();

                if (files) {
                    for (let [, value] of Object.entries(files)) {
                        this.entries.push(value);
                    }
                }

                this.data_loaded = true;
            });
        },
        human_readable_date: function(date_string) {
            let date_split = date_string.split("-"),
                date_object = new Date(
                    Date.UTC(
                        Number(date_split[0]),
                        Number(date_split[1]) - 1,
                        Number(date_split[2]),
                        12,
                        0,
                        0
                    )
                );

            return date_object.toLocaleDateString(undefined, {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        }
    }
};
</script>

<style>
.diario--entry {
    margin-bottom: 10px;
}

.text-wrap--break {
    display: inline-block;
    word-break: break-word;
    word-wrap: break-word;
}
</style>
